export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_HABIT_CATEGORIES_REQUEST",
  SUCCESS: "ADMIN_FETCH_HABIT_CATEGORIES_SUCCESS",
  FAILURE: "ADMIN_FETCH_HABIT_CATEGORIES_FAILURE",

  SUCCESS_SINGLE: "ADMIN_FETCH_HABIT_CATEGORY_SUCCESS",
  UPDATE_SUCCESS: "ADMIN_UPDATE_HABIT_CATEGORY_SUCCESS",
  CREATE_SUCCESS: "ADMIN_CREATE_HABIT_CATEGORY_SUCCESS",
  DELETE_SUCCESS: "ADMIN_DELETE_HABIT_CATEGORY_SUCCESS",
}

export interface ICategory {
  id: number;
  area: number;
  area_name: string;
  area_user_type: number;
  name: string;
  description: string;
  code: string;
}

interface NormalizedEntities {
  [key: string]: ICategory;
}

export interface IState {
  entities: NormalizedEntities;
  ids: string[];
  count: number;
  loading: boolean;
  error: any;
}
